import InvoiceModel           from 'Models/invoice/InvoiceModel';
import { computed }           from 'mobx';
import InvoicePrivateApiModel from 'modelx/models/abstracts/InvoicePrivateApiModel';

export default class InvoiceAggregatedDataModel extends InvoicePrivateApiModel {
	public _filters: ModelFiltersExtended<InvoiceModel['_filters'] & {
		'billingGroup.invoicingGroup.owner.partitionUrn': string;
		'billingPeriod': id;
		'invoiceItemGroups.invoiceItems.invoiceItemMetas.reference': string;
		'invoiceType.reference': string;
	}> = {};

	static get path(): string {
		return '/invoices/_aggregated_data';
	}

	@computed
	public get amountExclTax(): number {
		return this.get('amountExclTax');
	}

	@computed
	public get amountVat(): number {
		return this.get('amountVat');
	}

	@computed
	public get amountInclTax(): number {
		return this.get('amountInclTax');
	}

	@computed
	public get count(): number {
		return this.get('count', 0);
	}
}
